module.exports = __webpack_public_path__ + "img/116.bb649e42.jpg";